module.exports = __webpack_public_path__ + "img/colorable-flower.ffdd9bed.svg";